module.exports = __webpack_public_path__ + "videos/whats-new-53-hero_16x9_jp.a74c6f1.mp4";